import { combineReducers } from '@reduxjs/toolkit'
import loginUserInfoReducer from '../Common/Slice/LoginSlice'
import LoadSpinnerReducer from '../Common/Slice/LoadSpinnerSlice'

const rootReducer = combineReducers({
    loginUserInfo: loginUserInfoReducer,
    loadSpinner: LoadSpinnerReducer
  })
  
  export default rootReducer